import React, { useState, useEffect } from 'react';
import { Icon } from '../../Atoms';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

// Configuration des liens du footer
const FOOTER_LINKS = [
  {
    label: 'Mentions légales',
    url: 'https://www.cgrm.com/mentions-legales-des-espaces-connectes',
    external: true
  },
  {
    label: 'Politique des cookies',
    url: 'https://www.cgrm.com/politique-des-cookies-des-espaces-connectes',
    external: true
  },
  {
    label: 'Politique de confidentialité',
    url: 'https://www.cgrm.com/donnees-personnelles',
    external: true
  },
  {
    label: 'Réclamation',
    url: 'https://www.cgrm.com/reclamation',
    external: true
  }
];

// Configuration des icônes de navigation mobile
const MOBILE_NAV_ITEMS = [
  {
    path: '/',
    icon: 'Home',
    label: 'Accueil'
  },
  {
    path: '/profile',
    icon: 'Profile',
    label: 'Profil'
  },
  {
    path: '/contact',
    icon: 'Vector10',
    label: 'Contact'
  }
];

const FooterLink = ({ label, url, external }) => {
  const linkProps = external
    ? { href: url, target: "_blank", rel: "noopener noreferrer", className: "footer-links" }
    : { to: url, className: "footer-links" };

  const LinkComponent = external ? 'a' : Link;

  return <LinkComponent {...linkProps}>{label}</LinkComponent>;
};

// validation des props
FooterLink.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  external: PropTypes.bool
};

export default function OrganismFooter() {
  const location = useLocation();
  const sideBar = useSelector((state) => state.sideBar);
  const tuto = useSelector((state) => state.tuto);
  const [selectedPath, setSelectedPath] = useState('');

  const getFooterClassName = () => {
    return [
      'container-footer',
      sideBar.open && 'container-footer-mobile-open',
      tuto.step === 8 && 'footer-tuto-full-opacity'
    ].filter(Boolean).join(' ');
  };

  useEffect(() => {
    const path = location.pathname;
    const aux = path.split('/');
    setSelectedPath(aux.length === 0 ? '/' : `/${aux[1].toLowerCase()}`);
  }, [location.pathname]);

  return (
    <div className={getFooterClassName()}>
      <div className="container-footer-desktop">
        <div>
          CGRM {new Date().getFullYear()}
          {FOOTER_LINKS.map((link, index) => (
            <React.Fragment key={link.url}>
              {' - '}
              <span>
                <FooterLink {...link} />
              </span>
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="mobile-container-footer-icon">
        {MOBILE_NAV_ITEMS.map((item) => (
          <Link
            key={item.path}
            className={
              selectedPath === item.path
                ? 'container-footer-selected-icon'
                : 'container-footer-icon'
            }
            to={item.path}
            aria-label={item.label}
          >
            <Icon size={18} icon={item.icon} />
          </Link>
        ))}
      </div>
    </div>
  );
}